import React from "react";
import { ChevronLeft, X, Maximize2, Minimize2 } from "lucide-react";
import "../CSS/Header.css";
import { getFallbackBackView } from "../utils/navigationHelper";

function Header({
  setIsOpen,
  view,
  setView,
  setIsExpanded,
  isExpanded,
  logo,
  setupDetails,
  setActiveIcon,
}) {
  const getTitle = () => {
    switch (view) {
      case "chatList":
        return "Tickets";
      case "message":
      case "MessageDetails":
        return "Ticket Details";
      case "Help":
        return "Help center";
      case "News":
        return "News";
      case "Roadmap":
        return "Roadmap";
      case "DexKorOverview":
        return "Collections";
      case "Convo":
        return "Messages";
      case "AutomatedBot":
        return "AI Assistant";
      case "DexyAI":
        return "Dexy AI";
      default:
        return setupDetails?.widgetCustomizations?.partnerName || "Dexkor";
    }
  };

  const handleBack = () => {
    if (
      [
        "AIAgentInfo",
        "MetricsAndAttributes",
        "CDAInfo",
        "SupportContent",
        "DexKor",
      ].includes(view)
    ) {
      setIsExpanded(false);
    }

    const cust = setupDetails?.widgetCustomizations;
    const fallback = getFallbackBackView(setupDetails);

    if (view === "DexKor") {
      setView("DexKorOverview");
      if (setActiveIcon) setActiveIcon("help");
    } else if (view === "DexKorOverview") {
      setView("Help");
      if (setActiveIcon) setActiveIcon("help");
    } else if (view === "message" || view === "MessageDetails") {
      if (cust?.ticket !== false) {
        setView("chatList");
        if (setActiveIcon) setActiveIcon("tickets");
      } else {
        setView(fallback.view);
        if (setActiveIcon) setActiveIcon(fallback.icon);
      }
    } else {
      setView(fallback.view);
      if (setActiveIcon) setActiveIcon(fallback.icon);
    }
  };

  return (
    <div 
      className="dexkor-header transition-colors"
      style={{ backgroundColor: setupDetails?.widgetCustomizations?.backgroundColor || "#ffffff" }}
    >
      <div className="flex items-center gap-1.5 min-w-[32px]">
        <button
          onClick={handleBack}
          className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
          title="Back"
        >
          <ChevronLeft className="w-5 h-5 stroke-[2.2]" />
        </button>
      </div>

      <div className="font-bold text-slate-900 text-sm tracking-tight text-center truncate px-2 flex-1">
        {getTitle()}
      </div>

      <div className="flex items-center gap-1 min-w-[32px] justify-end">
        <button
          className="dexkor-close-button"
          onClick={() => setIsExpanded(!isExpanded)}
          title={isExpanded ? "Collapse" : "Expand"}
        >
          {isExpanded ? (
            <Minimize2 className="w-4 h-4 text-slate-500 hover:text-slate-800" />
          ) : (
            <Maximize2 className="w-4 h-4 text-slate-500 hover:text-slate-800" />
          )}
        </button>

        <button
          className="dexkor-close-button"
          onClick={() => {
            setIsOpen(false);
            setIsExpanded(false);
          }}
          title="Close"
        >
          <X className="w-4 h-4 text-slate-500 hover:text-slate-800" />
        </button>
      </div>
    </div>
  );
}

export default Header;

